import React from 'react';

import { SideNavigationItem, type SideNavigationItemProps } from '@lumapps/lumx-back-office/components/SideNavigation';
import { mdiImage } from '@lumapps/lumx/icons';
import { mediaLibraryAdminRoute } from '@lumapps/medias-library/routes';
import { adminTags } from '@lumapps/medias-tags/routes';
import { mediaTrashRoute } from '@lumapps/medias-trash/routes';
import { useSelector } from '@lumapps/redux/react';
import { GLOBAL, useTranslate } from '@lumapps/translations';

import { isUserAdmin } from '../../ducks/selectors';
import { MEDIAS } from '../../keys';

export interface MediaSideNavigationProps extends Partial<SideNavigationItemProps> {
    isAllowed: boolean;
}

const MediaSideNavigation = (props: Partial<MediaSideNavigationProps>) => {
    const { isAllowed, ...restOfProps } = props;
    const isAdmin = useSelector(isUserAdmin);

    const { translateKey } = useTranslate();

    if (!isAllowed) {
        return null;
    }

    return (
        <SideNavigationItem {...restOfProps} label={translateKey(MEDIAS.NAV_MEDIA)} icon={mdiImage} id="media">
            <SideNavigationItem label={translateKey(MEDIAS.MEDIA_LIBRARY)} route={mediaLibraryAdminRoute} />
            <SideNavigationItem label={translateKey(GLOBAL.TAGS)} route={adminTags()} />
            {isAdmin ? <SideNavigationItem label={translateKey(MEDIAS.MEDIA_TRASH)} route={mediaTrashRoute} /> : null}
        </SideNavigationItem>
    );
};

MediaSideNavigation.displayName = 'SideNavigationItem';

export { MediaSideNavigation };
